import { template } from 'lodash-es';

export const API = {
  GET_FLOW_INSTANCE: template('/flow?flowId=${flowId}'),
  SUBMIT_FLOW: template('/flow/submit?flowId=${flowId}&activityId=${activityId}&context=${context}'),
  NAV_CLICK: template('/flow/${navAction}?flowId=${flowId}&activityId=${activityId}&context=${context}'),
  RECENT_ENTRIES: template('/aux/${endpointUrl}'),
  PREVIOUS_ENTRIES: template('/aux/${endpointUrl}?activityId=${activityId}'),
  FEEDBACK: template('/aux/${endpointUrl}?instanceId=${instanceId}${feedbackQueryString}'),
  CONSENTS: template('/aux/${endpointUrl}'),
  RESOLVE_CONSENT: template('/aux/${endpointUrl}'),
  OPTIONS: template('/aux/${endpointUrl}'),
  UPLOAD_FILE: template('/file/upload?instanceId=${instanceId}&activityId=${activityId}'),
  UPLOADED_FILES: template('/file/uploadedFiles?instanceId=${instanceId}'),
  DELETE_RESULT: template('/aux/delete/result?${resultIdQS}'),
};

export const STORAGE_KEYS = {
  VALIDATION_TOKEN: 'validationToken',
  AUTH_TOKEN: 'authToken',
  API_KEY: 'apiKey',
  DFE_USER_TIME_ZONE: 'dfeUserTimeZone',
  FLOW_ID: 'masterFlowId',
  ACTIVITY_ID: 'activityId',
  CONTEXT_ID: 'dfeContext',
};

export const CONTEXT_IDS = {
  VOYAGE: 'voyage',
  CHATBOT: 'chatbot',
  CAP: 'cap',
  INDEPENDENCE: 'ibc',
};

export const SELF_ENTERED_SOURCE_NAMES = ['Self-Reported', 'CCHS', 'Self-entered', 'The Voyage'];
